import { render, staticRenderFns } from "./AddUserNoteDialog.vue?vue&type=template&id=7b0afccd&"
import script from "./AddUserNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddUserNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports